function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.605,
    height: 8.546,
    viewBox: "0 0 16.605 8.546",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16269",
    d: "M19.009 14.977a1.812 1.812 0 0 0-2.286 0L11.2 19.723l-5.525-4.746a1.793 1.793 0 0 0-1.582-.4 1.521 1.521 0 0 0-1.165 1 1.269 1.269 0 0 0 .462 1.36l6.666 5.734a1.812 1.812 0 0 0 2.286 0l6.668-5.732a1.259 1.259 0 0 0 0-1.968z",
    transform: "translate(-2.876 -14.536)",
    style: {
      fill: "#7c7c7c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.e35ec5b13b2b1c61c48b3da3f0e0840e.svg";
export { ForwardRef as ReactComponent };